<script lang="ts">
  import * as Tooltip from "$lib/components/ui/tooltip/index.js";
  import { cn } from "$lib/utility";
  import { Portal } from "bits-ui";

  let {
    content,
    tooltipComponent,
    side = "bottom",
    delayDuration = 25,
    className = "",
    children,
  } = $props<{
    content?: string;
    side?: "top" | "right" | "bottom" | "left";
    delayDuration?: number;
    className?: string;
    children?: any;
    tooltipComponent?: any;
  }>();
</script>

<Tooltip.Root {delayDuration}>
  <Tooltip.Trigger
    onfocus={(event) => (event.target as HTMLElement)?.blur()}
    class={cn("focus:outline-none focus:ring-0", className)}
  >
    {@render children()}
  </Tooltip.Trigger>
  <Portal>
    <Tooltip.Content
      class="!rounded-base bg-theme-background-primary px-2 py-1 text-2xs font-normal normal-case text-theme-text-primary dark:border-white/20 dark:bg-theme-background-primary"
      {side}
    >
      {#if content}
        <p>{content}</p>
      {/if}
      {#if tooltipComponent}
        {@render tooltipComponent()}
      {/if}
    </Tooltip.Content>
  </Portal>
</Tooltip.Root>
